import { motion } from "framer-motion";
import { CategoryBadge, PriorityBadge, StatusBadge } from "@/components/Badges";
import { CATEGORY_COLORS } from "@/lib/api";
import { Clock, User, Warning, Paperclip, Microphone, ArrowsClockwise, Lock, UsersThree } from "@phosphor-icons/react";

export default function TaskCard({ task, index = 0, onClick }) {
  const isPrivate = (task.visibility || "private") === "private";
  return (
    <motion.button
      data-testid={`task-card-${task.id}`}
      onClick={() => onClick(task)}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.04, 0.4), duration: 0.25 }}
      className="press text-left w-full bg-white border-2 border-black rounded-xl hard-shadow-sm overflow-hidden"
    >
      <div className="h-2 w-full" style={{ backgroundColor: CATEGORY_COLORS[task.category] || "#F3F4F6" }} />
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display font-bold text-lg leading-tight">{task.title}</h3>
          <div className="flex items-center gap-1 shrink-0">
            <span data-testid={`vis-badge-${task.id}`} title={isPrivate ? "Private — only you" : "Shared"}
              className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full border-2 border-black ${isPrivate ? "bg-[#F3F4F6] text-black/70" : "bg-[#DBEAFE] text-[#1E40AF]"}`}>
              {isPrivate ? <Lock size={11} weight="bold" /> : <UsersThree size={11} weight="bold" />}
              {isPrivate ? "Private" : "Shared"}
            </span>
            {task.recurring_series_id && <ArrowsClockwise size={18} weight="bold" data-testid={`recur-icon-${task.id}`} title="Recurring" />}
            {task.overdue && <Warning size={22} weight="fill" color="#FF3B30" />}
          </div>
        </div>
        {task.notes && <p className="text-sm text-black/60 mt-1 line-clamp-2">{task.notes}</p>}

        <div className="flex flex-wrap gap-2 mt-3">
          <CategoryBadge category={task.category} testid={`cat-${task.id}`} />
          <PriorityBadge priority={task.priority} testid={`prio-${task.id}`} />
          <StatusBadge status={task.status} testid={`status-${task.id}`} />
        </div>

        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-xs font-semibold text-black/60">
          {task.due_date && <span className="flex items-center gap-1"><Clock size={14} weight="bold" />{task.due_date}{task.start_time ? ` · ${task.start_time}` : ""}</span>}
          {task.assigned_to_name && <span className="flex items-center gap-1"><User size={14} weight="bold" />{task.assigned_to_name}</span>}
          {task.attachments?.length > 0 && <span className="flex items-center gap-1"><Paperclip size={14} weight="bold" />{task.attachments.length}</span>}
          {task.voice_notes?.length > 0 && <span className="flex items-center gap-1"><Microphone size={14} weight="bold" />{task.voice_notes.length}</span>}
        </div>
      </div>
    </motion.button>
  );
}
